import {Component, OnInit} from '@angular/core';

import {ManualsService, SubtitlesService} from "../../core";

@Component({
    selector: 'settings-manuals',
    templateUrl: './settings-manuals.component.html',
    styleUrls: ['./settings-manuals.component.scss']
})
export class SettingsManualsComponent implements OnInit {
    constructor(
        private subtitles: SubtitlesService,
        public manuals: ManualsService,
    ) {
    }

    ngOnInit(): void {
        this.manuals.getManualsList();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
